import React, { FC } from "react";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

interface IProps {
    meter_columns:any,
    data:any
};


const CostAvoidanceOverviewTable:FC<IProps> = (props) => {
    const columns = [
    {
      id:'date',
      accessorKey:'date',
      header: "Month/Year",
      cell: (props: any) => {
        return (
          <div className="center-all">{props.getValue()}</div>
        );
      },
      size: 200,
      enableColumnFilter: false,
      enableGlobalFilter: false,
    },
    {
        id:'avoidance',
        accessorKey: 'avoidance',
        header: "Total",
        cell: (props: any) => {
            return (
            <div className="center-all">{props.getValue() ? props.getValue()?.toLocaleString("en") : "0.0"}</div>
            );
        },
        size: 200,
        enableColumnFilter: false,
        enableGlobalFilter: false,
    }
]

    for (const column of props.meter_columns ){
        columns.push(
            {
                id:column,
                accessorKey: column,
                header: column.replaceAll('_', ' '),
                cell: (props: any) => {
                    return (
                    <div className="center-all">{props.getValue() ? props.getValue()?.toLocaleString("en") : "0.0"}</div>
                    );
                },
                size: 200,
                enableColumnFilter: false,
                enableGlobalFilter: false,
            }
        )
    }

    const table = useReactTable({
        data: props.data,
        columns: columns,
        getCoreRowModel: getCoreRowModel(),
      });

    return <div style={{width:'100%',marginTop:'2rem', display:'flex', justifyContent:'center',textAlign:'center'}}>
    <div className="stories-table" style={{ width: table.getTotalSize() + (props.data.length > 11 ? 20 : 5) , marginBottom: "2em", overflowX: "auto", maxHeight:'500px'}}>
        {table.getHeaderGroups().map((headerGroup: any) => (
          <div key={headerGroup.id} className="tr">
            {headerGroup.headers.map((header: any) => {
              return (
                <div
                  key={header.id}
                  className="th"
                  style={{ width: header.getSize() }}

                >
                  {header.column.columnDef.header}
                </div>
              );
            })}
          </div>
        ))}

        {table.getRowModel().rows.map((row: any) => (
          <div
            key={row.id}
            className="tr"
            style={{ width: table.getTotalSize() }}
          >
            {row.getVisibleCells().map((cell: any) => {
              return (
                <div
                  key={cell.id}
                  className="td"
                  style={{ width: cell.column.getSize() }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </div>
              );
            })}
          </div>
        ))}
        
    </div>
    </div>
};

export default CostAvoidanceOverviewTable;


